import React, { useState } from 'react';
import { buildSmugmugUrl, buildSmugmugSrcSet } from '../utils/image';

const heroWords = ['THE', 'DOJO', 'OF', 'PAIN'];
const heroImage = '/lead.jpeg';
const heroImageSrcSet = '/lead-768.jpg 768w, /lead.jpeg 1366w';

const cdnImageIds = [
  'mndZ99z',
  'kD5JvmX',
  'RWHZx2R',
  'X9m2xff',
  'R2JzgwM',
  'qDvRPLb',
  'QZvGR26',
  '8vgx4H6',
  '72SwrTX',
  'C7S4R3Z',
  '7kg5FMM',
  'RPsTCm8',
  'sPSsDk7',
  'PZ322ZS',
  'SQN4bJ4',
  'c4rHkQC',
  'MLHWh3L',
  'smQw9kv',
  '3FqN89T',
  'jvd486J',
];

const galleryImages = cdnImageIds.map((imageId, index) => ({
  imageId,
  alt: `Dojo gallery photo ${index + 1}`,
}));

const galleryImageSizes = '(max-width: 640px) 100vw, (max-width: 900px) 50vw, 25vw';

export default function Landing() {
  const [heroReady, setHeroReady] = useState(false);

  return (
    <section className="page landing-page">
      <div className="dojo-hero">
        <img
          className={`dojo-image ${heroReady ? 'visible' : ''}`}
          src={heroImage}
          srcSet={heroImageSrcSet}
          sizes="100vw"
          alt=""
          aria-hidden="true"
          fetchPriority="high"
          onLoad={() => setHeroReady(true)}
        />
        <div className="dojo-hero__content">
          <div className="dojo-words">
            {heroWords.map((word, index) => (
              <span key={word} className="dojo-word" style={{ animationDelay: `${index * 0.15}s` }}>
                {word}
              </span>
            ))}
          </div>
        </div>
      </div>

      <header id="about-dojo" className="section-header centered serif">
        <h1>What is Dojo?</h1>
        <p>Dojo is a competitive running group that trains in the heart of our nation’s capital. What started as a few lawyers logging workouts before billable hours has become a growing group of highly-driven runners balancing marathon training with the DC professional life.
Dojo trains to develop runners while fostering a welcoming community. 
</p>
      </header>

      <header  className="section-header centered serif">
        <h1>Philosophy</h1>
        <p>No dues. No qualifying times. Just a desire to train and race hard. We strive to create a training environment where every runner can achieve their goals. We achieve this through tailored training and a tight-knit team environment.
        </p>
      </header>




      <div className="gallery-row">
        {galleryImages.map(({ imageId, alt }) => (
          <figure key={imageId}>
            <img
              src={buildSmugmugUrl(imageId, 'L')}
              srcSet={buildSmugmugSrcSet(imageId)}
              sizes={galleryImageSizes}
              alt={alt}
              loading="lazy"
              decoding="async"
            />
          </figure>
        ))}
      </div>
    </section>
  );
}
